import { motion } from "framer-motion";

const EASE = [0.22, 1, 0.36, 1];

export function FadeUp({ children, delay = 0, y = 32, className }) {
  return (
    <motion.div
      className={className}
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, amount: 0.15 }}
      transition={{ duration: 0.8, delay, ease: EASE }}
    >
      {children}
    </motion.div>
  );
}

export function MaskedLines({ lines, className, lineClassName, delay = 0, mode = "load" }) {
  const animateProp = mode === "load" ? "animate" : "whileInView";
  const viewport = mode === "scroll" ? { once: true, amount: 0.4 } : undefined;
  return (
    <span className={`block ${className || ""}`}>
      {lines.map((line, i) => (
        <span key={i} className="block overflow-hidden pb-[0.08em] -mb-[0.08em]">
          <motion.span
            className={`block will-change-transform ${lineClassName || ""}`}
            initial={{ y: "112%" }}
            {...{ [animateProp]: { y: 0 } }}
            viewport={viewport}
            transition={{ duration: 0.9, delay: delay + i * 0.1, ease: EASE }}
          >
            {line}
          </motion.span>
        </span>
      ))}
    </span>
  );
}
